import { render, staticRenderFns } from "./OrganizationMation.vue?vue&type=template&id=0cb3f09e"
import script from "./OrganizationMation.vue?vue&type=script&lang=js"
export * from "./OrganizationMation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports